import classNames from 'classnames';
import { SectionWrapper } from '../layout/section-wrapper';

interface ChartSectionStateProps {
  className?: string;
  children: React.ReactNode;
}

export function ChartSectionState({ className, children }: ChartSectionStateProps) {
  const classes = classNames('justify-center', className);
  return (
    <SectionWrapper className={classes}>
      <div className="flex items-center h-full">
        <div className="text-center text-md text-brand-primary font-semibold">{children}</div>
      </div>
    </SectionWrapper>
  );
}
